import i18next from 'i18next';
import {
  EMAIL_MAX_LENGTH,
  EMAIL_PATTERN,
  isAlpha,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_PATTERN,
  STRING_FIELD_LENGTH,
  STRING_MIN_FIELD_LENGTH,
  USERNAME_PATTERN,
} from '@monorepo/types';

export const formNameValidation = () => {
  return {
    required: i18next.t('validations:name_is_required'),
    maxLength: formMaxLengthValidation(
      i18next.t('validations:name_maximum_length', {
        maximum_characters: STRING_FIELD_LENGTH,
      }),
    ),
    minLength: formMinLengthValidation(
      i18next.t('validations:name_minimum_length', {
        minimum_characters: STRING_MIN_FIELD_LENGTH,
      }),
    ),
    validate: (name: string) => {
      const splitName = name.split('');

      if (
        (splitName.length && splitName[0] === ' ') ||
        splitName[splitName.length - 1] === ' '
      ) {
        return i18next.t('validations:cannot_start_or_end_with_a_space');
      }

      if (name.indexOf('  ') !== -1) {
        return i18next.t('validations:cannot_have_multiple_spaces_in_a_row');
      }

      return (
        isAlpha(name, true) ||
        i18next.t('validations:name_must_contain_only_english_letters')
      );
    },
  };
};

export const formUserNameValidation = () => {
  return {
    maxLength: formMaxLengthValidation(
      i18next.t('validations:username_maximum_length', {
        maximum_characters: STRING_FIELD_LENGTH,
      }),
    ),
    minLength: formMinLengthValidation(
      i18next.t('validations:username_minimum_length', {
        minimum_characters: STRING_MIN_FIELD_LENGTH,
      }),
    ),
    pattern: {
      value: USERNAME_PATTERN,
      message: i18next.t('validations:username_pattern'),
    },
  };
};

export const formPasswordValidation = () => {
  return {
    required: i18next.t('validations:password_is_required'),
    pattern: {
      value: PASSWORD_PATTERN,
      message: i18next.t('validations:password_pattern'),
    },
    minLength: {
      value: PASSWORD_MIN_LENGTH,
      message: i18next.t('validations:password_minimum_length', {
        minimum_characters: PASSWORD_MIN_LENGTH,
      }),
    },
    maxLength: {
      value: PASSWORD_MAX_LENGTH,
      message: i18next.t('validations:password_maximum_length', {
        maximum_characters: PASSWORD_MAX_LENGTH,
      }),
    },
  };
};

export const formPhoneValidation = () => {
  return {
    required: i18next.t('validations:phone_number_is_required'),
    pattern: {
      value: /^[0-9+]{7,15}$/,
      message: i18next.t('validations:invalid_phone_number'),
    },
  };
};

export const formEmailValidation = () => {
  return {
    required: i18next.t('validations:email_is_required'),
    pattern: {
      value: EMAIL_PATTERN,
      message: i18next.t('validations:invalid_email_address'),
    },
    maxLength: {
      value: EMAIL_MAX_LENGTH,
      message: i18next.t('validations:email_maximum_length', {
        maximum_characters: EMAIL_MAX_LENGTH,
      }),
    },
  };
};

export const formMaxLengthValidation = (
  message: string,
  maxFormInputLength: number = STRING_FIELD_LENGTH,
) => {
  return {
    value: maxFormInputLength,
    message,
  };
};

export const formMinLengthValidation = (
  message: string,
  minFormInputLength: number = STRING_MIN_FIELD_LENGTH,
) => {
  return {
    value: minFormInputLength,
    message,
  };
};

export const formCountryValidation = () => {
  return {
    required: i18next.t('validations:country_is_required'),
  };
};

export const formRecaptchaValidation = () => {
  return {
    required: i18next.t('validations:verification_is_required'),
  };
};

export const formTermsValidation = () => {
  return {
    validate: (value: boolean) =>
      value || i18next.t('validations:must_accept_terms_and_conditions'),
  };
};

export const isDigitsOnly = (value: string): boolean => /^\d+$/.test(value);

export const validateBeneficiaryAccountName = (formValues: unknown): void => {
  const accountName = (formValues as any)?.beneficiary?.bank_details
    ?.account_name;
  if (accountName && isDigitsOnly(accountName)) {
    throw new Error(i18next.t('errors:account_name_digits_only'));
  }
};
